import { render, staticRenderFns } from "./addfileActivities.vue?vue&type=template&id=0346c3cf&scoped=true&"
import script from "./addfileActivities.vue?vue&type=script&lang=js&"
export * from "./addfileActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0346c3cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0346c3cf')) {
      api.createRecord('0346c3cf', component.options)
    } else {
      api.reload('0346c3cf', component.options)
    }
    module.hot.accept("./addfileActivities.vue?vue&type=template&id=0346c3cf&scoped=true&", function () {
      api.rerender('0346c3cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/components/addfileActivities.vue"
export default component.exports